import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Container from "@/components/marketing/Container";
import PackageCard from "./PackageCard";
import Reveal from "@/components/marketing/Reveal";
import { track } from "@/lib/analytics";

export default function PackagesGrid({ packages, loading, isFiltered, onResetFilters, selectedRegion }) {
  const trackedRef = useRef(false);
  useEffect(() => {
    if (loading || trackedRef.current) return;
    if (!packages || packages.length === 0) return;
    trackedRef.current = true;
    track("view_item_list", {
      item_list_name: "Packages",
      items: packages.slice(0, 10).map((p) => ({
        item_id: p.slug || p.id || p.name || "",
        item_name: p.name || "",
        item_category: p.category_tag || "",
        price: Number(p.sale_price) || 0,
        quantity: 1,
      })),
    });
  }, [loading, packages]);

  const [introDone, setIntroDone] = useState(false);
  useEffect(() => {
    if (!loading && packages.length > 0 && !introDone) {
      const t = setTimeout(() => setIntroDone(true), 900);
      return () => clearTimeout(t);
    }
  }, [loading, packages.length, introDone]);

  return (
    <section className="bg-[#f7f7f9] pt-4 pb-16 sm:pb-20 lg:pb-24">
      <Container className="relative">
        {loading ? (
          <div className="grid md:grid-cols-3 gap-5 lg:gap-6">
            {Array.from({ length: 3 }).map((_, i) => (
              <div
                key={i}
                className="bg-white border border-[#e8e6ef] rounded-xl h-96 animate-pulse"
              />
            ))}
          </div>
        ) : packages.length === 0 ? (
          isFiltered ? (
            selectedRegion === "UAE" ? (
              <div className="text-center py-16">
                <p className="text-[#6b6880] text-[15px] mb-4">
                  UAE packages are coming. In the meantime, see our full{" "}
                  <Link
                    to="/uae"
                    className="text-cobalt font-semibold underline underline-offset-4 hover:text-cobalt/80"
                  >
                    UAE distribution services
                  </Link>
                  .
                </p>
                <button
                  onClick={onResetFilters}
                  className="text-cobalt font-semibold underline underline-offset-4 hover:text-cobalt/80 text-[15px]"
                >
                  See all packages.
                </button>
              </div>
            ) : (
              <p className="text-center text-[#6b6880] text-[15px] py-16">
                No packages match those filters yet.{" "}
                <button
                  onClick={onResetFilters}
                  className="text-cobalt font-semibold underline underline-offset-4 hover:text-cobalt/80"
                >
                  See all packages.
                </button>
              </p>
            )
          ) : (
            <p className="text-center text-[#6b6880] text-[15px] py-16">
              No packages are available right now. Please check back soon.
            </p>
          )
        ) : introDone ? (
          <Reveal key={selectedRegion} variant="ack" mode="mount">
            <div className="grid md:grid-cols-3 gap-5 lg:gap-6">
              {packages.map((p) => (
                <PackageCard key={p.id || p.slug} pkg={p} />
              ))}
            </div>
          </Reveal>
        ) : (
          <Reveal variant="card" delay={0.08}>
            <div className="grid md:grid-cols-3 gap-5 lg:gap-6">
              {packages.map((p) => (
                <PackageCard key={p.id || p.slug} pkg={p} />
              ))}
            </div>
          </Reveal>
        )}
      </Container>
    </section>
  );
}